import React, { useState } from 'react';
import Modal, { useModal } from '../../Components/Modal';
import { useSession } from '../../Components/Session';
import { PageLoading } from '../../Components/Loading';
import { Link } from 'react-router-dom';
import { getEntityLink } from '../../Services/helpers';
import TimeAgo from '../../Components/Formatting/TimeAgo';
import Icon from '../../Components/Icons/Icon';
import ButtonRow from '../../Components/Button/ButtonRow';
import Button from '../../Components/Button/Button';
import { useAssistantContext } from '../../Components/Assistant';

const Notifications = () => {
    const [notificationsOpen, setNotificationsOpen] = useState(false);
    const [markingSeen, setMarkingSeen] = useState(false);
    const {notificationBadge, notificationsFetchError} = useSession();

    return <>
        <Icon
            size="2x"
            icon={'Bell'}
            badge={(notificationsFetchError || notificationBadge) ? true : null}
            onClick={() => setNotificationsOpen(true)}
        />

        <Modal title="Notifications" isOpen={notificationsOpen} setIsOpen={setNotificationsOpen} dismissible>
            {notificationsOpen && <Inner {...{markingSeen, setMarkingSeen}} />}
        </Modal>
    </>
}

const Inner = ({markingSeen, setMarkingSeen}) => {
    const {notifications, markAllNotificationsSeen} = useSession();
    const {closeModal} = useModal();

    const markAllSeen = async () => {
        closeModal();
        setMarkingSeen(true);
        await markAllNotificationsSeen();
        setMarkingSeen(false);
    }

    if (!notifications) {
        return <PageLoading />;
    }

    return <>
        <ul className="max-h-[75vh] flex flex-col divide-y divide-gray-200 dark:divide-gray-600 overflow-y-scroll">
            {notifications.map((n) => <Notification key={n.notificationId} {...n} closeModal={closeModal} />)}
        </ul>
        <ButtonRow>
            <Button theme="light" label="Close" onClick={closeModal} />
            <Button theme="primary" label="Mark all seen" loading={markingSeen} onClick={markAllSeen} />
        </ButtonRow>
    </>
}

const Notification = ({status, message, entityModel, entityId, addedAt, updatedAt, closeModal}) => {
    const {setAssistantOpen} = useAssistantContext();
    const isAssistantConversation = entityModel === 'Assistant/Conversation';

    const body = <>
        <div className="grow">
            <p className="font-bold">
                {status === 'Active' &&
                    <Icon  icon="Circle" theme="solid" className="fill-brand mr-2" size="0.5x" inline />
                }
                {getTitle(entityModel)}
            </p>
            <p className="">{message}</p>
            <p className="text-sm text-muted">
                <TimeAgo dateTime={updatedAt ?? addedAt} />
            </p>
        </div>
    </>;

    if (isAssistantConversation) {
        return <li className="py-4">
            <div
                className="flex flex-row cursor-pointer"
                role="button"
                onClick={() => {
                    closeModal();
                    setAssistantOpen(true);
                }}
            >
                {body}
            </div>
        </li>
    }

    return <li className="py-4">
        <Link
            className="flex flex-row"
            to={getEntityLink(entityModel, entityId)}
        >
            {body}
        </Link>
    </li>
}

const getTitle = (model, isActive) => {
    const map = {
        'Quotes/Quote':                 'Quote',
        'Payments/Account':             'Payment Account',
        'Payments/ConnectedBank':       'Connected Bank Account',
        'Payments/Payment':             'Payment',
        'Balances/Balance':             'Balance',
        'Marketplace/Subscription':     'Lead Generation',
        'Marketplace/Lead':             'Lead for Sale',
        'Customers/Customer':           'Customer',
        'Assistant/Conversation':       'Assistant conversation',
        'Voip/Account':                 'VoIP account',
        'Voip/Call':                    'Phone Call',
        'Users/AuthDevice':             'Security Device',
        'Users/LoginSession':           'Login',
        'Users/Grant':                  'Account access',
        'Questionnaires/Questionnaire': 'Questionnaire',
        'Soapy/WhatsNewNotification':   isActive ? 'Something\'s new 🎉' : 'What\'s New',
        'Soapy/SuggestionsNotification': isActive ? 'Vote on new suggestions 🗳️' : 'Suggestions',
    }

    return map[model] ?? model;
}



export default Notifications;
